<template>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-show="!modoVisualizacao && !modoAtendimento && !modoEdicao">
        <div class="container">
            <div class="col-left">
                <CalendarioSimplesComponent class="row-space"
                    :datasMarcadas="datasComEventos"
                    @mudouMes="setPeriodo"
                    @clicouData="selecionarData"
                />
                
                <div class="row-start"><button type="button" class="buttom-icon--close" @click="closeForm" /></div>
            </div>

            <div class="col-right">
                <table class="row-space">
                    <thead>
                        <tr>
                            <th class="col-width-date">Data</th>
                            <th class="col-width-char05">Hora</th>
                            <th>Nome/Assunto</th>
                            <th class="col-width-char20">Tipo</th>
                            <th class="col-width-char30">Situação</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(obj, index) in lsDados" :key="obj.id"
                            :class="getRowClass(index, obj.idstatus)"
                            @click="setVisualizar(obj)"
                        >
                            <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtagenda) }}</td>
                            <td class="col-width-char05 center">{{ Funcoes.formatTimeFromJson(obj.hragenda) }}</td>
                            <td>{{ [obj.nmpessoa, obj.assunto].filter(Boolean).join(' - ') || 'Informação indisponível' }}</td>
                            <td class="col-width-char20">{{ obj.nmtipo }}</td>
                            <td class="col-width-char30">{{ obj.nmstatus }}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="row-end">
                    <button type="button" class="buttom-icon--add" @click="modoEdicao=true"></button>
                </div>
            </div>
        </div>
    </div>


    <div v-if="modoAtendimento">
        <GabineteAgendaAtendimentoPage :idEdicao="idView" @close="modoAtendimento = false; atualizaPagina()" />
    </div>

    <div v-if="modoEdicao">
        <GabineteAgendaEditPage :strData="dataSelecionada" @close="modoEdicao = false; atualizaPagina()" />
    </div>

    <div v-if="modoVisualizacao">
        <GabineteAgendaViewPage :idView="idView" @close="modoVisualizacao = false; atualizaPagina()" />
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue'
import { genericPost } from '@/funcoes/api'
import { globalStore } from '@/globals'
import { Funcoes } from '@/funcoes/utils'
import CalendarioSimplesComponent from '@/components/CalendarioSimplesComponent.vue'
import GabineteAgendaAtendimentoPage from './GabineteAgendaAtendimentoPage.vue'
import GabineteAgendaEditPage from './GabineteAgendaEditPage.vue'
import GabineteAgendaViewPage from './GabineteAgendaViewPage.vue'
import MensagemAlerta from '@/components/MensagemAlerta.vue'

const emit=defineEmits(['close'])
const auxAno=ref(0);
const auxMes=ref(0);
const idView=ref(0);
const modoAtendimento=ref(false);
const modoEdicao=ref(false);
const modoVisualizacao=ref(false);
const msgAlerta=ref(null);
const lsDados = ref([]);
const datasComEventos = ref([]);
const dataSelecionada = ref(Funcoes.strDataAtual());

function closeForm() {emit('close');}

function setPeriodo({ mes, ano }){
    auxAno.value = ano;
    auxMes.value = mes;
    carregarEventos();
}

function atualizaPagina(){
    carregarEventos();
    lerEventos();
}

async function carregarEventos() {
    try{
        msgAlerta.value = null;
        const { datainicial, datafinal } = Funcoes.getIntervaloMes(auxMes.value, auxAno.value);
        const req = await genericPost('/gabinete/agenda/datas_com_eventos', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: datainicial, 
            datafinal: datafinal
        });
        datasComEventos.value = req.map(item => item.dtagenda);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`}
}

function getRowClass(index, idstatus){
    if (idstatus === 5) return 'destaque-row clickabe-row';
    return index % 2 === 0 ? 'even-row clickabe-row' : 'odd-row clickabe-row';
}

async function lerEventos() {
    try{
        msgAlerta.value = null;
        const req = await genericPost('/listas/gabinete_agenda', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: dataSelecionada.value, 
            datafinal: dataSelecionada.value});
        lsDados.value=req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`}
}

async function selecionarData(data) {
    try{
        dataSelecionada.value = Funcoes.formatDate(data);
        lerEventos();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`}
}

function setVisualizar(obj) {
    idView.value = obj.id;
    (obj.idstatus==4) ? modoAtendimento.value = true : modoVisualizacao.value = true;
}

onMounted(lerEventos)
</script>
  
<style scoped>
.container {
    display: flex;
    gap: 1rem;
}
  
.col-left {
  width: 320px;
  max-width: 320px;
  flex-shrink: 0;
}
  
.col-right {
    flex: 1;
}
</style>  